<app-bread-crumb></app-bread-crumb>

<app-announcement-info [FunctionID]="this.worldres.FunctionID"></app-announcement-info>

